import { h, Component, Element, Prop, Host, Watch } from '@stencil/core';
@Component({
  tag: 'pk-radio',
  styleUrl: './scss/pk-radio.scss',
  shadow: true,
})
export class PkRadio {
  // Own Properties
  // ====================

  // Reference to host HTML element
  // ===================================

  @Element() el!: HTMLPkRadioElement;

  // State() variables
  // Inlined decorator, alphabetical order
  // =======================================

  // Public Property API
  // ========================

  /** Set radio name */
  @Prop({ reflect: true }) name: string;

  /** Set radio options disabled */
  @Prop({ reflect: true }) disabled: boolean = false;

  // Prop lifecycle events
  // =======================

  /** Disable all options */
  @Watch('disabled')
  onDisabledPropChange() {
    this.getRadioOptions().forEach((radioElement: HTMLPkRadioOptionElement) => {
      radioElement.isDisabled = this.disabled;
    });
  }

  // Events section
  // Requires JSDocs for public API documentation
  // ==============================================

  // Component lifecycle events
  // Ordered by their natural call order
  // =====================================

  componentWillLoad() {
    this.setRadioOptionsName();
    if (this.disabled) {
      this.onDisabledPropChange();
    }
  }

  // Listeners
  // ==============

  // Public methods API
  // These methods are exposed on the host element.
  // Always use two lines.
  // Public Methods must be async.
  // Requires JSDocs for public API documentation.
  // ===============================================

  // Local methods
  // Internal business logic.
  // These methods cannot be called from the host element.
  // =======================================================

  private getRadioOptions = () => Array.from(this.el.querySelectorAll('pk-radio-option'));

  private setRadioOptionsName = () => this.getRadioOptions().forEach((radio) => (radio.name = this.name));

  // render() function
  // Always the last one in the class.
  // ===================================

  render() {
    return (
      <Host class="pk-radio">
        <slot onSlotchange={this.setRadioOptionsName} />
      </Host>
    );
  }
}
